import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useIndividualRecordStore } from '@/stores';

/**
 * Params for a link to one of the record's own tabs, taken from the record the
 * page is showing rather than the live `route.params`. Route targets built from
 * `route.params` re-resolve while navigating away from the record page, when
 * the params no longer exist.
 */
export function useRecordRouteParams() {
  const { sourceId, sourcePrimaryKey } = storeToRefs(
    useIndividualRecordStore(),
  );
  return computed(() => ({
    source_id: String(sourceId.value),
    source_primary_key: String(sourcePrimaryKey.value),
  }));
}
